import { render, staticRenderFns } from "./KBSelect.vue?vue&type=template&id=8121da62&scoped=true&"
import script from "./KBSelect.vue?vue&type=script&lang=js&"
export * from "./KBSelect.vue?vue&type=script&lang=js&"
import style0 from "./KBSelect.vue?vue&type=style&index=0&id=8121da62&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8121da62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VList,VListItem,VListItemTitle,VMenu})
